import styled from 'styled-components';

export const Column = styled.div`
  height: 60rem;
  max-height: 100%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  
  @media screen and (max-width: 1400px) {
    height: 34rem;
    overflow-y: scroll;
  }
`

export const Wrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem;
  background: transparent;

  button {
    background: var(--black-300);
    padding: 0.5rem 1rem;
    color: var(--white);
    margin-top: 0.6rem;
    border-radius: 0.25rem;
    transition: all 0.3s ease-in-out;

    &:hover {
      background: var(--black-400);
    }
  }
`

export const BackButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 0.5rem 0;
    
  p {
    text-decoration: underline;
    font-size: 1.1rem;
    cursor: pointer;
    text-align: center;
  }
`

export const DataSection = styled.div`
  display: flex;
  flex-direction: column;
  
`

export const Title = styled.h3`
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 0.6rem;
`

export const Coordinate = styled.p`
  color: var(--primary);
  font-weight: bold;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.2s ease-in-out;
  padding: 0.3rem 0.1rem;
  border-radius: 0.2rem;

  &:hover {
    border: 1px solid var(--primary);
  }
`

export const OccurrenceTypeBadge = styled.div`
  margin-top: 1.5rem;
  background: var(--black-400);
  padding: 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
`

export const OccurrenceIcon = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--black-100);
  border-radius: 0.25rem;
  padding: 0.85rem;
`

export const OccurrenceType = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.45rem;

  p {
    &:first-of-type {
      font-size: 1.1rem;
      font-weight: bold;
    }

    &:last-of-type {
      font-size: 1rem;
      color: var(--grey-100);
    }
  }
`

export const PolicemanName = styled.div`
  font-weight: bold;
  font-size: 1rem;
  color: var(--white);
`